import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import Icon from "@alboompro/boom-components/general/icon";
import axios from "axios";
import RangeInput from "../RangeInput/index";
import ColorPicker from "../ColorPickerComponent/index";

import {
  TypographyRange,
  Container,
  InputSelect,
  TransformOption,
  TypographyItems,
  LabelTypography,
  PickerAndTransform,
  InputItemTypography,
  WrapperIconTypography,
  RangeInputContainer,
  Tooltip,
} from "./styles";

class TypographyPopover extends Component {
  constructor() {
    super();
    this.state = {
      fonts: [],
      color: {
        r: 0,
        g: 0,
        b: 0,
        a: 1,
      },
      loadingFonts: true,
    };
  }

  // Function that run when recharge the component
  componentDidMount() {
    const { currentValue: data } = this.props;
    this.setState({
      valueSize: data.fontSize,
      valueSpacing: data.letterSpacing,
      color: data.color,
    });
    this.loadFontsList();
  }

  // Function for consume API
  loadFontsList = async () => {
    try {
      const response = await axios({
        method: "get",
        url: "https://prosite-api.alboompro.com/api/v1/fonts?collection=true",
        headers: {
          "app-code": "prosite",
          authorization: window.USER_TOKEN,
        },
      });
      const currentState = this.state;
      this.setState({
        ...currentState,
        fonts: response.data.fonts,
        loadingFonts: false,
      });
    } catch (err) {
      console.log(err);
    }
  };

  // Function for change font
  handleFont = (e) => {
    const { name, updaterFn, currentValue } = this.props;
    updaterFn({
      prop: name,
      value: { ...currentValue, fontFamily: e.target.value },
    });
  };

  // Function for change color
  handleColor = (e) => {
    const currentState = this.state;
    const { updaterFn, name, currentValue } = this.props;
    this.setState({ ...currentState, color: e.rgb });
    updaterFn({ prop: name, value: { ...currentValue, color: e.rgb } });
  };

  // Function for add letter spacing
  handleSpacing = (e) => {
    const { updaterFn, name, currentValue, letterSpacingOptions } = this.props;

    const value =
      e.target.value > letterSpacingOptions.max
        ? letterSpacingOptions.max
        : e.target.value;

    updaterFn({
      prop: name,
      value: { ...currentValue, letterSpacing: Number(value) },
    });
  };

  // Function for change font size
  handleSize = (e) => {
    const { updaterFn, name, currentValue, fontSizeOptions } = this.props;
    

    const value =
      e.target.value > fontSizeOptions.max
        ? fontSizeOptions.max
        : e.target.value;

    updaterFn({
      prop: name,
      value: { ...currentValue, fontSize: Number(value) },
    });
  };

  // Function for change transform of text (catalize, lowercase, uppercase and none)
  handleTransform = (type) => {
    const { updaterFn, name, currentValue } = this.props;
    updaterFn({
      prop: name,
      value: {
        ...currentValue,
        textTransform: type,
      },
    });
  };

  // Function for change word spacing
  handleWordSpacing = (e) => {
    const { updaterFn, name, currentValue } = this.props;
    updaterFn({
      prop: name,
      value: {
        ...currentValue,
        wordSpacing: Number(e.target.value),
      },
    });
  };

  // Function for change row spacing
  handleRowSpacing = (e) => {
    const { updaterFn, name, currentValue } = this.props;
    updaterFn({
      prop: name,
      value: {
        ...currentValue,
        lineHeight: Number(e.target.value),
      },
    });
  };

  render() {
    const {
      currentValue,
      fontSizeOptions,
      letterSpacingOptions,
      wordSpacingOptions,
      rowSpacingOptions,
      rangeSlideLabels,
      locale,
    } = this.props;

    const {
      fontSize,
      letterSpacing,
      textTransform,
      color,
      fontFamily,
      wordSpacing,
      lineHeight,
    } = currentValue;

    const { fonts, loadingFonts } = this.state;

    console.log(fontSize);

    return (
      <Container>
        <p>{I18n.t("editPanel.typography.labelFont")}</p>
        <TypographyItems>
          <InputSelect name="fonts" id="fontsSelect" onChange={this.handleFont}>
            {loadingFonts ? (
              <option value="">
                {I18n.t("editPanel.typography.optionLoading")}
              </option>
            ) : (
              <>
                {fonts.map((e) => (
                  <option
                    key={e.id}
                    value={e.family}
                    selected={fontFamily === e.family}
                  >
                    {e.family}
                  </option>
                ))}
              </>
            )}
          </InputSelect>
        </TypographyItems>
        {fontSize !== undefined && (
          <TypographyRange>
            <WrapperIconTypography>
              <img
                src="https://icons.alboompro.com/v1/bold/interface-essential/text-formating/595959/scale-vertical.svg"
                alt="Icon Font Size"
              />
            </WrapperIconTypography>
            <RangeInputContainer>
              <RangeInput
                min={fontSizeOptions.min}
                max={fontSizeOptions.max}
                step={fontSizeOptions.step}
                value={fontSize}
                onChange={this.handleSize}
              />
            </RangeInputContainer>
            <InputItemTypography
              type="number"
              min={fontSizeOptions.min}
              max={fontSizeOptions.max}
              step={fontSizeOptions.step}
              value={fontSize}
              onChange={this.handleSize}
            />
            {rangeSlideLabels && (
              <Tooltip>{rangeSlideLabels.fontSize[locale]}</Tooltip>
            )}
          </TypographyRange>
        )}
        {letterSpacing !== undefined && (
          <TypographyRange>
            <WrapperIconTypography>
              <img
                src="https://icons.alboompro.com/v1/bold/interface-essential/text-formating/595959/font-expand-horizontal.svg"
                alt="Icon Letter Spacing"
              />
            </WrapperIconTypography>
            <RangeInputContainer>
              <RangeInput
                min={letterSpacingOptions.min}
                max={letterSpacingOptions.max}
                step={letterSpacingOptions.step}
                value={letterSpacing}
                onChange={this.handleSpacing}
              />
            </RangeInputContainer>
            <InputItemTypography
              type="number"
              min={letterSpacingOptions.min}
              max={letterSpacingOptions.max}
              step={letterSpacingOptions.step}
              value={letterSpacing}
              onChange={this.handleSpacing}
            />
            {rangeSlideLabels && (
              <Tooltip>{rangeSlideLabels.letterSpacing[locale]}</Tooltip>
            )}
          </TypographyRange>
        )}
        {wordSpacingOptions && (
          <TypographyRange>
            <WrapperIconTypography>
              <img
                src="https://icons.alboompro.com/v1/bold/interface-essential/resize/595959/expand-horizontal-4.svg"
                alt="Icon Font Size"
              />
            </WrapperIconTypography>
            <RangeInputContainer>
              <RangeInput
                min={wordSpacingOptions.min}
                max={wordSpacingOptions.max}
                step={wordSpacingOptions.step}
                value={wordSpacing}
                onChange={this.handleWordSpacing}
              />
            </RangeInputContainer>
            <InputItemTypography
              type="number"
              min={wordSpacingOptions.min}
              max={wordSpacingOptions.max}
              step={wordSpacingOptions.step}
              value={wordSpacing}
              onChange={this.handleWordSpacing}
            />
            {rangeSlideLabels && (
              <Tooltip>{rangeSlideLabels.wordSpacing[locale]}</Tooltip>
            )}
          </TypographyRange>
        )}
        {rowSpacingOptions && (
          <TypographyRange>
            <WrapperIconTypography>
              <img
                src="	https://icons.alboompro.com/v1/bold/interface-essential/paragraphs/595959/paragraph-spacing.svg"
                alt="Icon row spacing"
              />
            </WrapperIconTypography>
            <RangeInputContainer>
              <RangeInput
                min={rowSpacingOptions.min}
                max={rowSpacingOptions.max}
                step={rowSpacingOptions.step}
                value={lineHeight}
                onChange={this.handleRowSpacing}
              />
            </RangeInputContainer>
            <InputItemTypography
              type="number"
              min={rowSpacingOptions.min}
              max={rowSpacingOptions.max}
              step={rowSpacingOptions.step}
              value={lineHeight}
              onChange={this.handleRowSpacing}
            />
            {rangeSlideLabels && (
              <Tooltip>{rangeSlideLabels.lineHeight[locale]}</Tooltip>
            )}
          </TypographyRange>
        )}
        <TypographyItems>
          <LabelTypography>
            {I18n.t("editPanel.typography.labelColor")}
          </LabelTypography>
          <PickerAndTransform>
            <ColorPicker color={color} label="" onChange={this.handleColor} />
          </PickerAndTransform>
        </TypographyItems>
        {textTransform && (
          <TypographyItems>
            <LabelTypography>
              {I18n.t("editPanel.typography.labelTransform")}
            </LabelTypography>
            <PickerAndTransform>
              <TransformOption
                active={textTransform === "none"}
                onClick={() => this.handleTransform("none")}
              >
                <Icon
                  kind="bold"
                  group="interface-essential"
                  category="delete"
                  file="delete.svg"
                  size="11"
                  color={textTransform === "none" ? "#44ADF8" : "#828282"}
                />
              </TransformOption>
              <TransformOption
                active={textTransform === "uppercase"}
                onClick={() => this.handleTransform("uppercase")}
              >
                <span>AA</span>
              </TransformOption>
              <TransformOption
                active={textTransform === "capitalize"}
                onClick={() => this.handleTransform("capitalize")}
              >
                <span>Aa</span>
              </TransformOption>
              <TransformOption
                active={textTransform === "lowercase"}
                onClick={() => this.handleTransform("lowercase")}
              >
                <span>aa</span>
              </TransformOption>
            </PickerAndTransform>
          </TypographyItems>
        )}
      </Container>
    );
  }
}

export default TypographyPopover;
